import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SickLeaveService} from '../services/sick-leave.service';
import {Absence} from '../models/absence.model';
import {Employee} from '../models/employee.model';
import {EmployeeService} from '../services/employee.service';
import {Signal, signal} from '@angular/core';
import {isCancelledAbsence, isErrorAbsence} from '../shared/absence-status.util';
import {DatevAuthStatusService} from '../services/datev-auth-status.service';
import {EauRowActionsComponent} from '../shared/eau-row-actions.component';

@Component({
    selector: 'app-sick-leave-overview',
    standalone: true,
    imports: [CommonModule, FormsModule, EauRowActionsComponent],
    templateUrl: './sick-leave-overview.component.html',
    styleUrls: ['./sick-leave-overview.component.css', '../shared/eau-row-actions.css']
})
export class SickLeaveOverviewComponent implements OnInit {
    sickLeaves = signal<Absence[]>([]);
    filteredSickLeaves = signal<Absence[]>([]);
    employees: Signal<Employee[]>;
    selectedEmployee = signal<string>('');
    error = signal<string | null>(null);
    loading = signal<boolean>(false);

    constructor(
        private sickLeaveService: SickLeaveService,
        private employeeService: EmployeeService,
        public datevAuthService: DatevAuthStatusService,
    ) {
        this.employees = this.employeeService.getEmployees();
    }

    ngOnInit() {
        this.loadSickLeaves();
    }

    private loadSickLeaves() {
        this.loading.set(true);
        this.error.set(null);

        this.sickLeaveService.getSickLeaves().subscribe({
            next: (sickLeaves: Absence[]) => {
                this.sickLeaves.set(sickLeaves);
                this.filterSickLeaves();
                this.loading.set(false);
            },
            error: (error: string) => {
                this.error.set(error);
                this.loading.set(false);
            }
        });
    }

    onEmployeeFilterChange() {
        this.filterSickLeaves();
    }

    private filterSickLeaves() {
        const currentEmployee = this.selectedEmployee();
        const currentSickLeaves = this.sickLeaves();

        if (!currentEmployee) {
            this.filteredSickLeaves.set(currentSickLeaves);
        } else {
            this.filteredSickLeaves.set(
                currentSickLeaves.filter(
                    leave => leave.mitarbeiterID === Number(currentEmployee)
                )
            );
        }
    }

    isCancelled = isCancelledAbsence;
    isError = isErrorAbsence;

    // Lädt die Liste nach einer erfolgreichen Zeilen-Aktion (EauRowActionsComponent) im
    // Hintergrund neu, ohne das globale loading()-Signal zu setzen. Ein Fehler hier wird bewusst
    // nicht über error() angezeigt, da das ebenfalls die ganze Tabelle ausblenden würde - die
    // Zeile behält dann einfach ihren zuletzt bekannten Stand.
    refreshSickLeavesSilently() {
        this.sickLeaveService.getSickLeaves().subscribe({
            next: (sickLeaves: Absence[]) => {
                this.sickLeaves.set(sickLeaves);
                this.filterSickLeaves();
            },
            error: () => {
            }
        });
    }
}
